export const getActiveNoteId = state => state.publicUI.activeNoteId

export const isNoteActive = (state, noteId) =>
  state.publicUI.activeNoteId === noteId

export const getExpandedNoteIds = state => state.publicUI.get('expandedNoteIds')

export const isNoteExpanded = (state, noteId) =>
  getExpandedNoteIds(state).includes(noteId)
